var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input-field',{attrs:{"label":_vm.label}},[_c('div',{staticClass:"tiptap-editor"},[_c('editor-content',{attrs:{"editor":_vm.editor}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }